import './DashboardCardComponent.scss';
import React from "react";

interface DashboardCardProps {
    title: string;
    className?: string;
    actions?: React.ReactNode;
    imageUrl?: any;
    providerName?: string;
    linkActions?: React.ReactNode;
}

const DashboardCardComponent = (props: React.PropsWithChildren<DashboardCardProps>) => {

    const {title, linkActions, providerName, imageUrl, actions, className, children} = props;

    return (
        <div className={`dashboard-card-component ${className}`}>
            {(title) && <div className={`dashboard-card-header`}>
                <div className="dashboard-card-title-wrapper">
                    <div className="dashboard-card-title">
                        {title}
                    </div>
                </div>
                {
                    actions && <div className="dashboard-card-actions">
                        {actions}
                    </div>
                }
            </div>}
            {
                (React.Children.count(children)) > 0 && <div className="dashboard-card-body">
                    {imageUrl ?
                        <div className={'dashboard-card-image-children-wrapper'}>
                            <div className="dashboard-card-image-wrapper">
                                <img src={imageUrl} className="dashboard-card-image" alt={title}/>
                                <div className={'dashboard-card-blurry-portion'}>
                                    <><div className={'provider-name'}>
                                            {providerName}
                                        </div>
                                        {
                                            providerName && <div className={'link-actions'}>{linkActions}</div>
                                        }
                                    </>
                                </div>
                            </div>
                            <div className={'dashboard-card-children'}>
                                {children}
                            </div>
                        </div> : <div  className={'dashboard-card-children'}>
                            {children}
                        </div>
                    }

                </div>
            }
        </div>
    );

};

export default DashboardCardComponent;
